import {getCancelToken} from '@shared/helpers/api'
import {SchemasOrderSaleSettle} from '@shared/schemas/order'

import getApi, {createWrapper} from '@web/helpers/api'

import {FetchSettlementHistory, FetchSettlementSummary, FetchSettlementDetail} from './interfaces'

const ApiBaseUrl = `/orderApi/orderSheet/sale/settlement`

const api = getApi(ApiBaseUrl)

/** 정산내역 조회 */
export async function fetchSettlementHistory({
    signal,
    startDate,
    endDate,
    keyword,
    category,
    detail,
    page,
}: {signal: AbortSignal} & FetchSettlementHistory['request']) {
    const source = getCancelToken()
    signal.addEventListener('abort', () => {
        source.cancel()
    })
    return createWrapper<SchemasOrderSaleSettle['/']['response']>(
        api.get('', {
            cancelToken: source.token,
            params: {
                startDate,
                endDate,
                keyword,
                category,
                detail,
                page,
            },
        }),
    )
}

/** 정산내역 > 정산요약 조회 */
export async function fetchSettlementSummary({startDate, endDate}: FetchSettlementSummary['request']) {
    return createWrapper<SchemasOrderSaleSettle['/summary']['response']>(
        api.get(`/summary`, {params: {startDate, endDate}}),
    )
}

/** 정산상세 조회 */
export async function fetchSettlementDetail({settleObjectNo}: FetchSettlementDetail['request']) {
    return createWrapper<SchemasOrderSaleSettle['/:settleObjectNo']['response']>(api.get(`/${settleObjectNo}`))
}

/** 지급 보류 상세 내역 조회 */
export async function fetchSettlementPayHold({startDate, endDate}: SchemasOrderSaleSettle['/pay/hold']['request']) {
    return createWrapper<SchemasOrderSaleSettle['/pay/hold']['response']>(
        api.get(`/pay/hold`, {params: {startDate, endDate}}),
    )
}
